import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchCteBegin: null,
    fetchCteSuccess: ['payload'],
    fetchCteFailure: null,
})

export const fetchCtes = state => dispatch => {
    dispatch(Creators.fetchCteBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/ctes',
        data: state
    })
    .then(response => dispatch(Creators.fetchCteSuccess(response.data)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
            showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchCteFailure())
    })
}

export const downloadXML = (button, chave) => dispatch => {
    button.firstChild.classList.remove('fa-download')
    button.firstChild.classList.add('fa-spinner', 'fa-spin')
    return getHTTPClient()({
        method: 'GET',
        url: `/ctes/xml/${chave}`,
        responseType: 'blob'
    }).then(
        response => {
            const url = URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${chave}.xml`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            button.firstChild.classList.add('fa-download')
            button.firstChild.classList.remove('fa-spinner', 'fa-spin')
        },
        error => {
            button.firstChild.classList.add('fa-download')
            button.firstChild.classList.remove('fa-spinner', 'fa-spin')
            checkStatusCode(error.response.status)
            if (error.response) {
                showNotification(error.response.data.message, 'alert-danger')
            } else if (error.request) {
                if (process.env.NODE_ENV === 'development' )
                    console.log(error.request)
                    showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
            } else {
                showNotification(error.message, 'alert-danger')
            }               
        }
    )
}

export const getDACTE = (button, chave) => dispatch => {
    button.firstChild.classList.remove('fa-eye')
    button.firstChild.classList.add('fa-spinner', 'fa-spin')
    const link = window.open('about:blank', '_blank')
    link.document.write("<p>A DACTE está carregando...</p>")
    return getHTTPClient()({
        method: 'GET',
        url: `/ctes/dacte/${chave}`,
        responseType: 'blob'
    }).then(
        response => {
            const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            link.location.href = url
            button.firstChild.classList.add('fa-eye')
            button.firstChild.classList.remove('fa-spinner', 'fa-spin')
        },
        error => {
            button.firstChild.classList.add('fa-eye')
            button.firstChild.classList.remove('fa-spinner', 'fa-spin')
            link.close()
            checkStatusCode(error.response.status)
            if (error.response) {
                showNotification(error.response.data.message, 'alert-danger')
            } else if (error.request) {
                if (process.env.NODE_ENV === 'development' )
                    console.log(error.request)
                    showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
            } else {
                showNotification(error.message, 'alert-danger')
            }               
        }
    )
}